import React, { ReactNode } from 'react'
import styles from './Tag.module.sass'

interface Props {
  label?: string
  size?: 'lg'
  className?: string
  icon?: ReactNode
}

const Tag = (props: Props) => {
  const { label = undefined, size = 'lg', className = '', icon = null } = props

  return label ? (
    <div className={`${styles.root} ${styles[`root--${size}`]} ${className}`}>
      {!!icon && <span className={styles.icon}>{icon}</span>} {label}
    </div>
  ) : (
    <></>
  )
}

export default Tag
